import { createAction, props } from "@ngrx/store";
import {
  BetslipFilterItem,
  C_OveraskDataBetPlacement,
  CloseTicketItem,
  CloseTicketResult,
  CombinationMulticastInput,
  LineItem,
  OddItem,
  RaceLineItem,
  SmartLineItem,
  SmartMarketInput,
  StraightMulticastInput,
  oddsUpdateItem,
  removeTicketModel,
  ticketState,
} from "@ticket/models";
import { RecoverTicketModel } from "../models/betslip-actions.models";
import { BetslipProviderModel } from "../models/betslip-provider.model";
import { C_FreeBetTicket, C_FreeBetVoucher } from "../models/free-bet-ticket.model";
import { StakeModel } from "../models/stake.model";
import { TicketGlobalsDataModel } from "../models/ticket-globals-data.model";
import { TicketItemTypesEnum } from "../utils/ticket.constants";

export const AddCombinationMulticast = createAction(
  "[ticket] Add CombinationMulticast",
  props<{ combinationMulticastInput: CombinationMulticastInput; combinationMulticastItem: RaceLineItem }>(),
);
export const AddSingleResult = createAction("[ticket] Add SingleResult", props<{ game: LineItem }>());
export const AddSingleResultById = createAction("[ticket] Add SingleResultById", props<{ betId: number }>());
export const AddSmartMarketItem = createAction(
  "[ticket] Add SmartMarket Item",
  props<{ smartMarketRequest: SmartMarketInput; smartMarketBet: SmartLineItem }>(),
);
export const AddSmartMarketSelection = createAction(
  "[ticket] Add SmartMarket Selection",
  props<{ selection: LineItem }>(),
);
export const AddStraightMulticast = createAction(
  "[ticket] Add StraightM",
  props<{ straightMulticastInput: StraightMulticastInput; straightMulticastItem: RaceLineItem }>(),
);
export const AmountLocalLineItemUpdate = createAction(
  "[ticket] Amount Local LineItem Update",
  props<{ selectedLine: unknown; value: string }>(),
);
export const AmountLocalTotalUpdate = createAction(
  "[ticket] Amount Local Total Update",
  props<{ value: number }>(),
);
export const BetbuilderOddsChange = createAction("[ticket] Betbuilder Odds Change");
export const ChangeFilter = createAction("[ticket] Change Filter", props<{ filter: number }>());
export const ChangeFilterAndSetOddErrors = createAction(
  "[ticket] Change Filters And Set Odd Errors",
  props<{ filter: number }>(),
);
export const CheckForErrors = createAction("[ticket] Check For Errors");
export const CloseBet = createAction(
  "[ticket] Close Bet",
  props<{ groupKey: string; acceptPrevious?: boolean }>(),
);
export const ClosedTicketResult = createAction(
  "[ticket] Closed Ticket Result",
  props<{ closeTicketResult: CloseTicketResult; newOdds: OddItem[] }>(),
);
export const CloseKeyboard = createAction("[ticket] Keyboard Close");
export const CloseTicketResultAndOddsUpdate = createAction(
  "[ticket] Closed Ticket Result And Odds Update",
  props<{ closeTicketResult: CloseTicketResult; newOdds: OddItem[] }>(),
);
export const FreeBetsAdd = createAction(
  "[ticket] FreeBets Add",
  props<{ voucher: C_FreeBetVoucher; personalized: boolean; filterSelected: BetslipFilterItem }>(),
);
export const FreeBetsCancel = createAction("[ticket] FreeBets Cancel", props<{ voucherCode: string }>());
export const FreeBetsSetVouchers = createAction(
  "[ticket] FreeBets Set Vouchers",
  props<{ vouchers: C_FreeBetTicket[] }>(),
);
export const FreeBetsUpdateStakeAndPlaceFB = createAction(
  "[ticket] FreeBets Update Stake And Place FB",
  props<{ stake: StakeModel }>(),
);
export const FreeBetsUpdateValidations = createAction(
  "[ticket] FreeBets Update Validations",
  props<{ nextStep: string; betSlip: BetslipProviderModel; freebetStake?: StakeModel }>(),
);
export const FreeBetsUpdateVouchers = createAction("[ticket] FreeBets Update Vouchers");
export const InitFilters = createAction("[ticket] Init Filters", props<{ filters: BetslipFilterItem[] }>());
export const KeepSelection = createAction(
  "[ticket] Keep Selection",
  props<{ cuotaAccept: string; userLogged: boolean }>(),
);
export const MarketLocked = createAction(
  "[ticket] Market Locked",
  props<{ odds: oddsUpdateItem[]; oddItems: OddItem[] }>(),
);
export const NoAction = createAction("[ticket] No Action");
export const OpenKeyboard = createAction("[ticket] Keyboard Open");
export const OveraskCloseBet = createAction("[ticket] Overask Close Bet");
export const OveraskMaxStake = createAction(
  "[ticket] Overask Max Stake",
  props<{ overaskData: C_OveraskDataBetPlacement; status: number; stake: StakeModel }>(),
);
export const OveraskRejected = createAction(
  "[ticket] Overask Rejected",
  props<{ overaskData: C_OveraskDataBetPlacement; status: number }>(),
);
export const OveraskStart = createAction(
  "[ticket] Overask Start",
  props<{ overaskData: CloseTicketItem; closeBetStake: number }>(),
);
export const OveraskStartPolling = createAction(
  "[ticket] Overask Start Polling",
  props<{ overaskData: C_OveraskDataBetPlacement; status: number }>(),
);
export const OveraskTimeout = createAction(
  "[ticket] Overask Timeout",
  props<{ overaskData: C_OveraskDataBetPlacement; status: number }>(),
);
export const PlaceBet = createAction(
  "[ticket] Place Bet",
  props<{ groupKey: string; acceptPrevious?: boolean }>(),
);
export const PresentDuplicatedBetAcceptance = createAction(
  "[ticket] present Duplicated Bet Acceptance",
  props<{ ticketResponse: CloseTicketResult }>(),
);
export const RecoverTicket = createAction("[ticket] Recover Ticket", props<RecoverTicketModel>());
export const RemoveItem = createAction(
  "[ticket] Remove Item",
  props<{ id: number; itemType: TicketItemTypesEnum }>(),
);
export const RemoveItems = createAction("[ticket] Remove Items", props<{ ids: number[] }>());
export const RemoveSmartMarketAllSelections = createAction("[ticket] Remove SmartMarket All Selections");
export const RemoveSmartMarketSelection = createAction(
  "[ticket] Remove SmartMarket Selection",
  props<{ id: number }>(),
);
export const RemoveTicket = createAction("[ticket] Remove Ticket", props<removeTicketModel>());
export const RestartBetslip = createAction("[ticket] Restart Betslip");
export const SaveBetSlip = createAction("[ticket] Save BetSlip", props<{ betSlip: BetslipProviderModel }>());
export const SaveBetSlipAndEvaluateFlow = createAction(
  "[ticket] Save BetSlip And Evaluate Flow",
  props<{ betSlip: BetslipProviderModel; checkFilterChange: boolean }>(),
);
export const SetBetOddAcceptance = createAction("[ticket] Set Bet Odds Aceptance");
export const SetFilters = createAction("[ticket] Set Filters", props<{ globalsData: TicketGlobalsDataModel }>());
export const SetFilterSelected = createAction(
  "[ticket] Set Filter Selected",
  props<{ globalsData: TicketGlobalsDataModel }>(),
);
export const SetLineItemSelected = createAction(
  "[ticket] Set Item Selected",
  props<{ lineItemSelection: LineItem | SmartLineItem | RaceLineItem }>(),
);
export const SetLineItemUnselected = createAction("[ticket] Set Item Unselected");
export const SetMultiStake = createAction("[ticket] Set Multi Stake", props<{ multiStake: StakeModel }>());
export const SetOddErrors = createAction("[ticket] Set Odd Errors");
export const SetStake = createAction("[ticket] Set Stake", props<{ stake: StakeModel }>());
export const SetSystemBetType = createAction(
  "[ticket] Set System Bet Type",
  props<{ newTicketState: ticketState; systemStake: StakeModel }>(),
);
export const SetXStateAndAuthorization = createAction("[ticket] Set X-State And Authorization");
export const TicketError = createAction("[ticket] Ticket Error", props<{ error: string; code?: unknown }>());
export const ToggleKeyboard = createAction("[ticket] Keyboard Toggle");
export const UpdateAndChangeToSingles = createAction(
  "[ticket] Update And Change To Singles",
  props<{ cuotaAccept: string; userLogged: boolean }>(),
);
export const UpdateAndCheckForErrors = createAction(
  "[ticket] Update And Check For Errors",
  props<{ cuotaAccept: string; userLogged: boolean }>(),
);
export const UpdateOdds = createAction("[ticket] Update Odds", props<{ odds: OddItem[] }>());
export const UpdateStake = createAction("[ticket] Update Stake", props<{ stake: StakeModel }>());
export const UpdateTicket = createAction(
  "[ticket] Update Ticket",
  props<{ cuotaAccept: string; userLogged: boolean }>(),
);
